import { useListUserCauseSelections } from 'core/Api';
import { ClickableOptionsCard } from 'core/Components';
import { NavLink } from 'react-router-dom';
import { Anchor, ButtonMantine, Group, Modal, Stack, Text, ThemeIcon } from 'ui';
import { IconDelete } from 'ui/Icons';

import { PagesUrl } from '../../../../utils';
import { useManageMyCausesModalProvider } from './ManageMyCausesProvider';

const MyCauses = () => {
  const { data: causeSelections } = useListUserCauseSelections();

  const { setMeta, openNextStep } = useManageMyCausesModalProvider({ id: 'ManageCauses' });

  return (
    <ClickableOptionsCard>
      {causeSelections?.map((selection) => (
        <ClickableOptionsCard.Row
          key={selection.cause_id}
          title={selection.cause.name}
          onClick={() => {
            setMeta({ cause: selection.cause });
            openNextStep();
          }}
          rightSection={
            <ThemeIcon variant="subtle" color={'cerise'}>
              <IconDelete />
            </ThemeIcon>
          }
        />
      ))}
    </ClickableOptionsCard>
  );
};

const ManageMyCausesContent = () => {
  return (
    <Stack mb="lg">
      <Group>
        <Text fw={600} fz={18} style={{ flexGrow: 1 }} c="gray.8">
          My Causes
        </Text>
        <Anchor component={NavLink} to={PagesUrl.CAUSES} size="sm" fw={600}>
          <ButtonMantine size="compact-sm" variant="subtle">
            Add a Cause
          </ButtonMantine>
        </Anchor>
      </Group>

      <MyCauses />
    </Stack>
  );
};

const ManageMyCausesModal = () => {
  const { opened, close } = useManageMyCausesModalProvider({ id: 'ManageCauses' });

  return (
    <Modal opened={opened} onClose={() => close()} title="Manage My Causes">
      <ManageMyCausesContent />
    </Modal>
  );
};

export { ManageMyCausesModal };
